export default __webpack_public_path__ + "static/media/Sorcerer's Robes of Imperial Assent.979d9998.jpg";